export default "__VITE_ASSET__VFssOUIF__"